import { render } from "./SBrowse.vue?vue&type=template&id=083722b8&ts=true"
import script from "./SBrowse.vue?vue&type=script&lang=ts"
export * from "./SBrowse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__